import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "../auth";
import { LinearProgress } from "@mui/material";

function OAuthRedirect() {
	const [params] = useSearchParams();
	const navigate = useNavigate();

	const oauth2: OAuth2Context = useContext(AuthContext);

	useEffect(() => {
		async function handleCodeExchange() {
			// get code parameter from querystring
			const code = params.get("code");
			if (!code) {
				throw new Error("Invalid OAuth redirect code.");
			}

			await oauth2.performCodeExchange(code);

			// Use passed through returnTo state value to determine where to redirect now
			const authStateStr = params.get("state");
			let returnTo = "/";
			if (authStateStr) {
				const authState = JSON.parse(authStateStr!);
				returnTo = authState.returnTo;
			}

			navigate(returnTo, { replace: true });
		}
		handleCodeExchange();
	}, [navigate, oauth2, params]);

	return <LinearProgress />;
}

export default OAuthRedirect;
